import React from 'react';
import { cn } from '../utils/cn';

export interface ILMSCardProps extends Omit<React.HTMLAttributes<HTMLDivElement>, 'title'> {
  title?: React.ReactNode;
  subtitle?: React.ReactNode;
  actions?: React.ReactNode;
  padded?: boolean;
  noBorder?: boolean;
}

export function ILMSCard({ title, subtitle, actions, padded = true, noBorder, className, children, ...rest }: ILMSCardProps) {
  return (
    <div
      className={cn(
        'bg-white rounded-lg shadow-card',
        !noBorder && 'border border-ink-300/20',
        className
      )}
      {...rest}
    >
      {(title || actions) && (
        <div className={cn('flex items-start justify-between gap-3 border-b border-ink-300/15', padded ? 'p-4 sm:p-5' : 'p-3')}>
          <div className="min-w-0">
            {title && <h3 className="text-card-title truncate">{title}</h3>}
            {subtitle && <p className="text-secondary text-ink-500 mt-0.5">{subtitle}</p>}
          </div>
          {actions && <div className="flex items-center gap-2 shrink-0">{actions}</div>}
        </div>
      )}
      <div className={padded ? 'p-4 sm:p-5' : undefined}>{children}</div>
    </div>
  );
}
